export const MAIN_MENU_SUPPORT_CSS = `
@keyframes mm-card-in {
  0% { opacity: 0; transform: translateY(14px) scale(0.985); filter: blur(6px); }
  100% { opacity: 1; transform: translateY(0) scale(1); filter: blur(0); }
}

@keyframes mm-title-enter {
  0% { opacity: 0; transform: translateY(-34px) scale(0.94); filter: blur(10px); }
  100% { opacity: 1; transform: translateY(0) scale(1); filter: blur(0); }
}

@keyframes mm-signal-pulse {
  0%, 100% { opacity: 0.9; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.1); }
}

@keyframes mm-fade-up {
  0% { opacity: 0; transform: translateY(14px); }
  100% { opacity: 1; transform: translateY(0); }
}

@keyframes mm-play-breathe {
  0%, 100% {
    filter:
      drop-shadow(0 0 16px rgba(150, 90, 230, 0.55))
      drop-shadow(0 0 32px rgba(80, 140, 230, 0.35));
  }
  50% {
    filter:
      drop-shadow(0 0 28px rgba(180, 110, 240, 0.85))
      drop-shadow(0 0 56px rgba(100, 160, 240, 0.55));
  }
}

@keyframes mm-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

@keyframes mm-shine-pass {
  0% { transform: translateX(0) skewX(-18deg); opacity: 0; }
  12% { opacity: 0.95; }
  48% { opacity: 0.95; }
  64% { transform: translateX(430%) skewX(-18deg); opacity: 0; }
  100% { transform: translateX(430%) skewX(-18deg); opacity: 0; }
}

@keyframes mm-chev-pulse-l {
  0%, 100% { opacity: 0.7; transform: translateX(0); }
  50% { opacity: 1; transform: translateX(3px); }
}

@keyframes mm-chev-pulse-r {
  0%, 100% { opacity: 0.7; transform: translateX(0); }
  50% { opacity: 1; transform: translateX(-3px); }
}

@keyframes mm-live-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.45; }
}

@media (max-height: 900px) and (pointer: fine) {
  .main-menu__card--home {
    gap: 9px;
    padding: 10px 14px;
  }

  .main-menu__title-word {
    font-size: clamp(2.35rem, 6.3vw, 4.35rem);
  }

  .main-menu__btn--cta {
    height: 86px;
    font-size: 1.65rem;
    margin-top: 14px;
  }

  .main-menu__setup-panel {
    padding: 10px 14px;
  }

  .main-menu__diff-blurb,
  .main-menu__footer-left {
    display: none;
  }
}

@media (max-height: 720px) and (pointer: fine) {
  .main-menu__title-word {
    font-size: clamp(2rem, 5vw, 3.35rem);
  }

  .main-menu__subtitle {
    display: none;
  }

  .main-menu__btn--cta {
    height: 68px;
    font-size: 1.35rem;
  }

  .main-menu__btn--secondary,
  .main-menu__btn--primary {
    height: 48px;
  }

  .main-menu__signal-icon {
    width: 30px;
    height: 30px;
    margin-bottom: 4px;
  }
}

@media (max-width: 820px), (pointer: coarse) {
  .main-menu__card {
    width: calc(100vw - 18px);
    max-width: 560px;
    max-height: calc(100vh - 18px);
    padding: 22px 18px 16px;
  }

  .main-menu__card--home {
    width: min(620px, 94vw);
    padding: 8px;
    gap: 10px;
  }

  .main-menu__title-word {
    font-size: clamp(2.4rem, 12vw, 4.2rem);
  }

  .main-menu__subtitle {
    font-size: 0.66rem;
    letter-spacing: 0.3em;
    gap: 10px;
  }

  .main-menu__subtitle-bar {
    width: 30px;
  }

  .main-menu__btn--cta {
    height: 82px;
    font-size: 1.45rem;
    letter-spacing: 0.14em;
    margin-top: 12px;
  }

  .main-menu__btn--cta .main-menu__btn-label {
    gap: 18px;
  }

  .main-menu__setup-grid {
    grid-template-columns: 1fr;
  }

  .main-menu__diff-btn {
    min-height: 42px;
    padding: 9px 8px;
    font-size: 0.72rem;
  }

  .main-menu__btn--secondary,
  .main-menu__btn--primary {
    height: 44px;
    font-size: 0.88rem;
    letter-spacing: 0.16em;
  }

  .main-menu__btn-sub {
    display: none;
  }

  .main-menu__bottom-row {
    grid-template-columns: 1fr 1fr;
  }

  .main-menu__btn--utility {
    min-height: 42px;
  }

  .main-menu__footer {
    flex-direction: column;
    gap: 5px;
  }
}

@media (max-width: 480px) {
  .main-menu__card--home {
    gap: 8px;
  }

  .main-menu__signal-icon {
    width: 34px;
    height: 34px;
    margin-bottom: 6px;
  }

  .main-menu__btn--cta {
    height: 74px;
    font-size: 1.28rem;
  }

  .main-menu__secondary-stack {
    gap: 7px;
  }

  .main-menu__setup-panel {
    padding: 8px 10px;
  }

  .main-menu__diff-group,
  .main-menu__diff-group--maps {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (orientation: landscape) and (max-height: 480px) and (pointer: coarse) {
  .main-menu__card--home {
    width: min(920px, 96vw);
    max-height: calc(100vh - 12px);
    display: grid;
    grid-template-columns: minmax(240px, 0.85fr) minmax(420px, 1.15fr);
    align-items: center;
    column-gap: 16px;
  }

  .main-menu__title-word {
    font-size: clamp(2rem, 8vw, 3rem);
  }

  .main-menu__subtitle {
    display: none;
  }

  .main-menu__actions-wrap {
    min-width: 0;
  }

  .main-menu__btn--cta {
    height: 58px;
    margin-top: 0;
    font-size: 1.1rem;
  }

  .main-menu__setup-grid {
    grid-template-columns: 1fr 1fr;
  }

  .main-menu__diff-blurb,
  .main-menu__footer {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .main-menu__bg-image,
  .main-menu__bg-bloom,
  .main-menu__bg-rim,
  .main-menu__bg-grain,
  .main-menu__spark,
  .main-menu__signal-icon,
  .main-menu__title-wrap,
  .main-menu__btn,
  .main-menu__btn--cta::before,
  .main-menu__shimmer,
  .main-menu__chev,
  .main-menu__footer-left::before,
  .main-menu__card {
    animation: none !important;
  }
}
`;
